export function serialize(draft) {
    const serializedDraft = {
        ...draft,
    };

    return serializedDraft;
}
